module.exports = __webpack_public_path__ + "img/6.6aff7c36.jpg";